import { NgModule } from '@angular/core';
import { PopOverMenusComponent } from 'src/app/components/pop-over-menus/pop-over-menus.component';

@NgModule({
    declarations: [PopOverMenusComponent],
    exports: [PopOverMenusComponent]
})
export class MyComponentsModule{}